var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"log",rawName:"v-log",value:({
    type: 'show',
    name: 'CARD',
    value: {
      card_type: 'user_small',
    }
  }),expression:"{\n    type: 'show',\n    name: 'CARD',\n    value: {\n      card_type: 'user_small',\n    }\n  }"}],staticClass:"nikename-warp"},[_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.$t('user')))])]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.data),function(item){return _c('UserItemFollow',{key:item.name,attrs:{"card-type":'user_small',"data":item,"is-login-status":_vm.isLoginStatus}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }